<template>
  <div>
    <div class="contact">
      <div class="ornament">
        <img src="../assets/lamp2.svg" alt />
      </div>
      <div class="content">
        <h1>Get in touch</h1>
        <p>
          Whether you want to make
          <strong>living</strong> lovely,
          <strong>re-design</strong> your home, furnishing, decoration,
          <strong>re-invent</strong> your establishment or style your space, we are ready for you to get in touch.
        </p>

        <h2>Allow Us</h2>
        <p>We'll contact you as soon as possible</p>
        <form name="contact" method="POST" action="/contact/sucess" data-netlify="true">
          <input type="text" name="name" placeholder="name" />
          <input type="email" name="email" placeholder="email" />
          <input type="phone" name="phone" placeholder="phone" />
          <textarea name="message" placeholder="comment(optional)"></textarea>
          <button class="button" type="submit">Send</button>
        </form>

        <h2>Links</h2>
        <p>Ramasrey Sahani</p>
        <div class="contactlinks">
          <a href="tel:+919892191429">
            <p>+91-9892191429</p>
          </a>
          <a href="mailto:sahanidecors@gmail.com">
            <p>sahanidecors@gmail.com</p>
          </a>
        </div>

        <h2>Mumbai, India</h2>
        <p>400074</p>
      </div>
    </div>
    <MyFooter :footer-image="footerImage" />
  </div>
</template>

<script>
import MyFooter from "@/components/MyFooter";
export default {
  name: "About",
  data: function() {
    return {
      footerImage: require("../assets/tv.svg")
    };
  },
  components: {
    MyFooter
  }
};
</script>

<style scoped lang="scss">
.contact {
  margin: 2rem 1rem;

  @include mediumScreen {
    display: flex;
    width: 85vw;
    margin: auto;
  }
  .content {
    flex: 1;
    max-width: 40rem;
    @include mediumScreen {
      margin-bottom: -4rem;
      /* background: skyblue; */
    }

    h1 {
      margin-top: 3rem;
      color: $accentPrimary;
      font-size: 3rem;
    }

    h2 {
      font-size: 2rem;
      margin-top: 2rem;
    }
    p {
      font-size: 1.3rem;
      text-align: justify;
    }

    form {
      display: flex;
      flex-direction: column;
      input,
      input[type="text"],
      textarea {
        font-family: "primaryFont";
        font-size: 1.2rem;
        margin: 0.2rem;
        border: none;
        border-bottom: solid 1px $darkPrimary;
        max-width: 25em;
        padding: 1rem;

        &:focus {
          outline: none;
          border: none;
          border-bottom: solid 1.5px $accentSecondary;
        }
      }

      textarea {
        height: 6em;
        resize: none;
      }

      button {
        margin: 0.5rem;
        padding: 0.7rem;
        max-width: 15rem;
        background: transparent;
        color: $accentSecondary;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          border: solid 2px $accentPrimary;
          color: $accentPrimary;
          background: $accentPrimaryLight;
        }
      }
    }

    .contactlinks {
      /* color: $accentQuadry; */
      font-weight: bold;
    }
  }
  .ornament {
    /* background: lime; */
    display: none;
    @include mediumScreen {
      padding-top: 10rem;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: baseline;
    }

    img {
      width: 15vw;
    }
  }
}
</style>
